import { getSession } from './index';
import { getSecureBaseUrl } from '../../../services/UrlMapperService';
import { HttpService } from '../../../services/HttpService';
import { apiUrls } from '../../../constants/apiUrl';

import './polymapbundle';

const getCookieValue = (name) => document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';

export const Polymap = () => {
  const selectorsObjList = [];
  const commonSelector = {
    selectorCondition: 'h1,h2,h3',
  };
  selectorsObjList.push(commonSelector);
  const clickselector = [];
  const options = {};
  options.clickselectors = clickselector;
  options.selectors = selectorsObjList; // pass the selectors array
  options.polySize = 150; // size of the polymapvfr window
  options.poly_ypos = 0;
  options.distanceMetrics = true; // will get the elements away from the current region
  /* append to root dom element of the application or can keep it null */
  options.appendToWindowElement = null;
  options.maxstackelements = 50; // stack size is reaching more than 50
  options.inactivetimeout = 30; // fire on inactive if the user goes away from the current window or any other window
  options.cutoftime = 30; // fire on cut oftime where even if the user does not perform any action
  options.callBack = loggingCallback;
  options.sessionID = getCookieValue('digital_ig_session') || 'polyworker'; // pass the unique id of the user
  options.poly_xpos = 0;
  options.isDebug = false; // make it false while pushing to QA
  options.zIndex = 0; // zindex at polymapvfr should be loaded at inside the window
  options.isWindowScroll = true;
  // options.showAnalytics = true;
  if (getSession('enablePolyMap') === 'Y') {
    window.initPolyMap(options);
  }

  function loggingCallback(loggingArr, polymapinsight, currentviewregion, typeofcallback) {
    if (!typeofcallback.includes('waitTime') && getSession('enablePolyMap') === 'Y') {
      console.log('polymapinsight>>>', currentviewregion);
      const data = {
        messageType: 'INFO',
        eventType: 'polyMapInfo',
        subEventType: 'polyMapInfo',
        App_id: '5GHOME',
        version: 1,
        pageUrl: window.location.href,
        flowName: window.vzdl.page.flow || '',
        polyArrObj: JSON.stringify(loggingArr),
        ...polymapinsight,
      };
      HttpService.post(`${getSecureBaseUrl()}${apiUrls().errorLogUrl}`, data).catch((e) => {
        console.log('error', e);
      });
    }
  }
};
